import React, { useState } from "react";
import { PlayCircle, Clock, ArrowRight } from "lucide-react";

export default function ScheduleDemoCTA() {
  const [form, setForm] = useState({ name: "", email: "", company: "" });

  const buildMailto = (extraBody) => {
    const subject = encodeURIComponent("Demo Request - Somm.ai");
    const lines = [
      "Hi David,",
      "",
      "I'd like to schedule a demo of Somm.ai.",
      "",
      form.name ? `Name: ${form.name}` : "",
      form.email ? `Email: ${form.email}` : "",
      form.company ? `Company: ${form.company}` : "",
      extraBody || "",
      "",
      "Thanks!",
    ].filter(Boolean);
    const body = encodeURIComponent(lines.join("\n"));
    return `mailto:david@somm.ai?subject=${subject}&body=${body}`;
  };

  const onSubmit = (e) => {
    e.preventDefault();
    window.location.href = buildMailto();
  };

  return (
    <section className="max-w-7xl mx-auto px-6 my-24">
      <div
        className="card-soft p-10 md:p-14 grid md:grid-cols-2 gap-10 items-center"
        style={{ background: "linear-gradient(180deg, #f7fbf8 0%, #ffffff 100%)" }}
      >
        <div>
          <h2 className="text-4xl md:text-5xl font-extrabold tracking-tight">Schedule a Demo</h2>
          <p className="mt-4 text-lg text-[#4b5566]">Ready to level up your on-premise business?</p>
          <div className="mt-6 flex flex-wrap gap-4">
            <a href="https://www.somm.ai/meeting" target="_blank" rel="noreferrer" className="btn-green">
              Schedule a Demo <ArrowRight size={18} />
            </a>
          </div>
          <div className="mt-8 flex flex-wrap gap-6 text-sm text-[#4b5566]">
            <div className="inline-flex items-center gap-2">
              <PlayCircle size={18} className="text-[#22c55e]" /> See Live Demo
            </div>
            <div className="inline-flex items-center gap-2">
              <Clock size={18} className="text-[#22c55e]" /> Less than 30min
            </div>
          </div>
        </div>
        <form className="space-y-4" onSubmit={onSubmit}>
          <input
            className="form-input"
            placeholder="Full name"
            required
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
          />
          <input
            className="form-input"
            type="email"
            placeholder="Work email"
            required
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
          />
          <input
            className="form-input"
            placeholder="Company name"
            value={form.company}
            onChange={(e) => setForm({ ...form, company: e.target.value })}
          />
          <button type="submit" className="btn-green w-full justify-center">
            Request a Demo
          </button>
        </form>
      </div>
    </section>
  );
}
